export default "__VITE_ASSET__RmjKeC_M__"